module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3j2ge"))).then(() => parcelRequire('cvs7o'));